const HamburgerMenu = () => {
  const toogleMenuBtn = () => {
    const windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;

    //faz o icone do hamburguer mudar quando abre ou fecha o menu lateral
    if (windowSize > 767) humberIcon.classList.toggle("open");

    if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.getAttribute("data-sidebar-size") === "sm"
        ? document.documentElement.setAttribute("data-sidebar-size", "")
        : document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else if (windowSize > 1025) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.getAttribute("data-sidebar-size") === "lg"
        ? document.documentElement.setAttribute("data-sidebar-size", "sm-hover")
        : document.documentElement.setAttribute("data-sidebar-size", "lg");
    } else if (windowSize <= 767) {
      document.body.classList.add("vertical-sidebar-enable");
      document.documentElement.setAttribute("data-sidebar-size", "lg");
    }
  };

  return (
    <button
      onClick={toogleMenuBtn}
      type="button"
      className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
      id="topnav-hamburger-icon"
    >
      <span className="hamburger-icon">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
  );
};

export default HamburgerMenu;
